<div class="footer fixed no-print" [ngClass]="footerCssClass">
    <div class="pull-left">
        Copyright <i class="fa fa-copyright" aria-hidden="true"></i> {{today | date:'yyyy' }} Overall Parts Solutions All rights reserved.
        <label class="text-primary">TraxPartners Version: {{ versionNumber }}</label>
    </div>
</div>
